import AiconSelect from '@/components/AiconSelect';
import Aupload from '@/components/Aupload/Icon';

export default {
  name: 'CformItem',
  components: {
    AiconSelect,
    Aupload,
  },
  props: {
    config: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      rand: 0,
      option: [],
    }
  },
  watch: {
    config: {
      immediate: true,
      handler() {
        this.create();
      },
    }
  },
  created() {
    this.create();
    this.$nextTick(() => this.search());
  },
  destroyed() {
    this.create = null;
    this.search = null;
    this.switch = null;
    this.filter = null;
    this.relate = null;
    this.format = null;
  },
  methods: {
    create() {
      this.rand = Math.random();
    },
    search() {
      const { type = '', action = '', path = '', link = '', kind = '', flag = '', index = '', field = '' } = this.config;
      if (type != '' && (type === 'select' || type === 'cascader')) {
        const { optionAction = '' } = this.$store.state;
        if (optionAction != '' || path != '') {
          let url = action != '' ? action : (path != '' ? path : (link != '' ? link : optionAction));
          let value = kind != '' ? kind : (flag != '' ? flag : (index != '' ? index : field));
          if (url != '') FN.get(url, { field: this.switch(value) }).then(({ data = [] }) => this.option = data);
        }
      }
    },
    switch(name = '', symbol = '_') {
      return name.replace(/([A-Z])/g, `${symbol}$1`).toLowerCase();
    },
    filter(form = {}) {
      const data = {};
      for (let a in form) {
        if ((a != undefined && a != 'undefined') && (form[a] != '' && form[a] != '%%' && form[a] != 'null' && form[a] != 'undefined' && form[a] != null && form[a] != undefined)) {
          data[a] = form[a];
        }
      }
      return data;
    },
    relate(value = '', array = []) {
      let object = {};
      if (value != '') array.length > 0 && array.forEach(a => {
        if ((a.value || a.code || a.id) && (a.value == value || a.code == value || a.id == value)) object = a;
      });
      return object;
    },
    change(a, b, c) {
      this.$emit('input', b, c);
      this.$emit('change', b, c);
      a.change && a.change(b, c);
    },
    format({ form, text, label, title, field, dicts, table, ...props }) {
      const words = text || label || title || '';
      const labels = (a = {}) => (typeof a == 'string') ? a : (a.label || a.title || a.text || a.name);
      const values = (a = {}) => (typeof a == 'string') ? a : (a.value || a.code || a.id);
      if (props.render) return props.render(this.filter(form), props);
      if (!props.type) return <el-input v-model={form[field]} clearable on-change={e => this.change(props, e)} placeholder={props.placeholder || `请输入${words}`} style={{ ...props.style }} {...{ props }} />
      if (table && (props.type == 'year' || props.type == 'month' || props.type == 'date' || props.type == 'time')) {
        return <el-input v-model={form[field]} clearable on-change={e => this.change(props, e)} placeholder={props.placeholder || `请输入${words}`} style={{ ...props.style }} {...{ props }} />
      }
      switch (props.type) {
        case 'input': return <el-input v-model={form[field]} clearable on-change={e => this.change(props, e)} placeholder={props.placeholder || `请输入${words}`} style={{ ...props.style }} {...{ props }} />
        case 'number': return <el-input v-model={form[field]} clearable on-change={e => this.change(props, e)} placeholder={props.placeholder || `请输入${words}`} style={{ ...props.style }} {...{ props }} />
        case 'password': return <el-input v-model={form[field]} clearable on-change={e => this.change(props, e)} placeholder={props.placeholder || `请输入${words}`} style={{ ...props.style }} show-password {...{ props }} />
        case 'select': return (
          <el-select v-model={form[field]} clearable filterable collapse-tags on-change={e => this.change(props, e, this.relate(e, props.data && props.data.length > 0 ? props.data : (this.option.length > 0 ? this.option : [])))} placeholder={props.placeholder || `请选择${words}`} style={{ ...props.style }} {...{ props }}>
            {props.data && props.data.length > 0 ?
              (props.data.map((a, b) => <el-option key={b} label={labels(a)} value={`${values(a)}`} />))
              :
              (this.option.map((a, b) => <el-option key={b} label={labels(a)} value={`${values(a)}`} />))
            }
          </el-select>
        );
        case 'cascader': return <el-cascader clearable filterable v-model={form[field]} options={props.data && props.data.length > 0 ? props.data : (this.option.length > 0 ? this.option : [])} on-change={e => this.change(props, e)} placeholder={props.placeholder || `请选择${words}`} style={{ ...props.style }} {...{ props }} />;
        case 'checkbox': return (<el-checkbox v-model={form[field]} on-change={e => this.change(props, e)} style={{ ...props.style }} {...{ props }}>{words}</el-checkbox>);
        case 'checkboxGroup': return (
          <el-checkbox-group v-model={form[field]} on-change={e => this.change(props, e)} style={{ ...props.style }} {...{ props }}>
            {props.data && props.data.length > 0 ?
              (props.data.map((a, b) => <el-checkbox key={b} label={values(a)}>{labels(a)}</el-checkbox>))
              :
              (this.dicts.map((a, b) => <el-checkbox key={b} label={values(a)}>{labels(a)}</el-checkbox>))
            }
          </el-checkbox-group>
        );
        case 'radio': return (
          <el-radio-group v-model={form[field]} on-change={e => this.change(props, e)} style={{ ...props.style }} {...{ props }}>
            {props.data && props.data.length > 0 ?
              (props.data.map((a, b) => <el-radio key={b} label={values(a)}>{labels(a)}</el-radio>))
              :
              (this.dicts.map((a, b) => <el-radio key={b} label={values(a)}>{labels(a)}</el-radio>))
            }
          </el-radio-group>
        );
        case 'switch': return <el-switch v-model={form[field]} on-change={e => this.change(props, e)} active-value="1" inactive-value={"0" || null} active-text="启用" inactive-text="禁用" active-color="#13ce66" style={{ ...props.style }} {...{ props }} />
        case 'daterange': return <el-date-picker v-model={form[field]} align="center" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" type={props.type} clearable on-change={e => this.change(props, e)} placeholder={props.placeholder || `请选择${words}`} start-placeholder="开始" end-placeholder="结束" style={{ width: props.width || '100%', ...props.style }} {...{ props }} />
        case 'date': return <el-date-picker v-model={form[field]} align="center" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" type={props.type} clearable on-change={e => this.change(props, e)} placeholder={props.placeholder || `请选择${words}`} style={{ width: props.width, ...props.style }} {...{ props }} />
        case 'time': return <el-time-picker v-model={form[field]} align="center" type={props.type} clearable on-change={e => this.change(props, e)} placeholder={props.placeholder || `请选择${words}`} style={{ width: props.width, ...props.style }} {...{ props }} />
        case 'year': return <el-date-picker v-model={form[field]} align="center" type={props.type} clearable on-change={e => this.change(props, e)} placeholder={props.placeholder || `请选择${text}`} style={{ width: props.width, ...props.style }} {...{ props }} />
        case 'month': return <el-date-picker v-model={form[field]} align="center" type={props.type} clearable on-change={e => this.change(props, e)} placeholder={props.placeholder || `请选择${text}`} style={{ width: props.width, ...props.style }} {...{ props }} />
        case 'color': return <el-color-picker v-model={form[field]} size={this.size} on-change={e => this.change(props, e)} placeholder={props.placeholder || `请选择${text}`} style={{ width: props.width, ...props.style }} {...{ props }} />
        case 'image': return <Aupload key={this.rand} v-model={form[field]} src={form[field]} on-change={e => this.change(props, e)} placeholder={props.placeholder || `请选择${words}`} style={{ ...props.style }} {...{ props }} />
        case 'upload': return <Aupload key={this.rand} v-model={form[field]} src={form[field]} on-change={e => this.change(props, e)} placeholder={props.placeholder || `请选择${words}`} style={{ ...props.style }} {...{ props }} />
        case 'icon': return <AiconSelect key={this.rand} v-model={form[field]} on-change={e => this.change(props, e)} placeholder={props.placeholder || `请选择${words}`} style={{ width: props.width, ...props.style }} {...{ props }} />
        case 'iconSelect': return <AiconSelect key={this.rand} v-model={form[field]} on-change={e => this.change(props, e)} placeholder={props.placeholder || `请选择${words}`} style={{ width: props.width, ...props.style }} {...{ props }} />
        case 'custom': return props.render(this.filter(form), props);
        default: return <el-input v-model={form[field]} clearable on-change={e => this.change(props, e)} placeholder={props.placeholder || `请输入${words}`} style={{ ...props.style }} {...{ props }} />
      }
    }
  },
  render() {
    return this.format(this.config);
  }
}